import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { GlobalService } from 'src/app/services/shared/global.service';
import { UserService } from 'src/app/services/users/user.service';

@Component({
  selector: 'app-change-user-password',
  templateUrl: './change-user-password.component.html',
  styleUrls: ['./change-user-password.component.css']
})
export class ChangeUserPasswordComponent implements OnInit{
  form!: FormGroup;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  isProcessing: boolean = false;
  submitted: boolean = false;
  public userId: string | null = null;
  public userFullName: string | null = null;

  constructor(
    private userService: UserService,
    private formBuilder: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private activatedRoute: ActivatedRoute,
  ){
    this.form = this.formBuilder.group({
      password: ['', Validators.required],
      password_confirmation: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.userId = param['get']('user_id')
      this.userFullName = param['get']('name')
    })

    if(!this.userId){
      //Navigate back to users list with error
      this.globalService.setGlobalErrorMessage("Unable to select user for password change. Please try again!");
      this.router.navigate(['settings/users-list']);
    }
  }

  handleSubmit():void{
    this.submitted=true;
    this.isProcessing = true;

    if (this.form.valid) {
      if(this.form.value.password.length<8){

        this.isProcessing = false;
        this.errorMessage="Password MUST be atleast 8 characters long!"

      }else if(!this.form.value.password.match(/[a-z]+/)){

        this.isProcessing = false;
        this.errorMessage="Password MUST contain atleast one lowercase letter!"

      }else if(!this.form.value.password.match(/[A-Z]+/)){

        this.isProcessing = false;
        this.errorMessage="Password MUST contain atleast one uppercase letter!"

      }else if(!this.form.value.password.match(/[0-9]+/)){

        this.isProcessing = false;
        this.errorMessage="Password MUST contain atleast one digit!"

      }else if(!this.form.value.password.match(/[$@#&!%]+/)){

        this.isProcessing = false;
        this.errorMessage="Password MUST contain atleast one special character e.g $@#&!%"

      }else if(this.form.value.password !== this.form.value.password_confirmation){

        this.isProcessing = false;
        this.errorMessage="Password and Password Confirmation DO NOT match!"

      }else{
        const formData = {
          ...this.form.value,
        };
  
        this.userService.changePassword(formData,this.userId).subscribe(response => {
          if(response.status==='success'){
  
            this.submitted=false;
            this.isProcessing = false;
            this.globalService.setGlobalSuccessMessage(response.message);
           
            // Redirect back to users list
            this.router.navigate(['settings/users-list']);
          }else if(response.status==='error'){
            this.submitted=false;
            this.isProcessing = false;
            this.globalService.setGlobalErrorMessage(response.message);
          }else{
            this.submitted=false;
            this.isProcessing = false;
            this.errorMessage="Oops! A problem was encountered while processing your request. Please try again or consult your system administrator.";
          }
        },
        error => {
          this.isProcessing = false;
          this.errorMessage=error;
        });
      }
    }else{
      this.isProcessing = false;
    }
  }
}
